export class FlowController {
    constructor(flowService) {
        flowService.nextFlow();
    }
}

FlowController.$inject = ['flowService'];
